declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    clarity?: (...args: unknown[]) => void;
    posthog?: {
      capture?: (event: string, props?: Record<string, unknown>) => void;
    };
  }
}

function sanitizePayload(props?: Record<string, unknown>): Record<string, unknown> | undefined {
  if (!props) return undefined;
  
  try {
    const sanitized: Record<string, unknown> = {};
    
    for (const [key, value] of Object.entries(props)) {
      if (value === undefined || typeof value === "function") {
        continue;
      }
      
      if (typeof value === "bigint") {
        sanitized[key] = value.toString();
        continue;
      }
      
      if (typeof value === "string" && value.length > 500) {
        sanitized[key] = value.slice(0, 500) + "...";
        continue;
      }
      
      sanitized[key] = value;
    }
    
    return sanitized;
  } catch {
    return undefined;
  }
}

export function track(eventName: string, props?: Record<string, unknown>): void {
  try {
    const sanitizedProps = sanitizePayload(props);
    
    if (typeof window.gtag === "function") {
      try {
        window.gtag("event", eventName, sanitizedProps);
      } catch {
        // gtag threw, ignore
      }
    }
    
    if (typeof window.clarity === "function") {
      try {
        window.clarity("event", eventName);
      } catch {
        // clarity threw, ignore
      }
    }
    
    if (window.posthog && typeof window.posthog.capture === "function") {
      try {
        window.posthog.capture(eventName, sanitizedProps);
      } catch {
        // posthog threw, ignore
      }
    }
  } catch {
    // Outer catch - never throw
  }
}
